import * as React from 'react';
import ReactPlayerLoader from '@brightcove/react-player-loader';
import { Box } from 'grommet';

export const BrightcoveReactPlayer = (props) => {
    let video = props.video;

    return <Box className="vid-player" fill>
        <Box className="c-player__screen" data-vjs-player="true" fill>
            <ReactPlayerLoader accountId={video.accountId} playerId={video.playerKey} videoId={video.id}
                data-bc-trackingid={video.uaid} data-application-id embedId="default" options={{...props.videoJsOptions}}
                onSuccess={props.onSuccess} onFailure={props.onFailure} />
        </Box>
    </Box>;
}
